import React from 'react';
import CustomHeader from '../components/layout/CustomHeader';
import CustomFooter from '../components/layout/CustomFooter';
import './About.css';

const developers = [
  {
    name: 'Pranjal Pandey',
    role: 'Full Stack Developer',
    image: require('../assets/profile.jpg'),
    description: `The driving force behind IntelUniVen’s technical journey, Pranjal blends logic with leadership. From shaping the architecture to setting the strategic roadmap, he ensures every line of code aligns with the bigger picture. With his strong grasp of both frontend finesse and backend depth, Pranjal makes sure that IntelUniVen runs like a well-oiled machine — fast, secure, and future-ready.\n\n“Code is temporary. Impact is permanent.”`
  },
  {
    name: 'Ayush Shukla',
    role: 'Full Stack Developer',
    image: require('../assets/images/ayush.jpg'),
    description: `Ayush crafts the experiences users love. Every button you click, every animation you admire — that’s Ayush's magic. With a sharp eye for design and a passion for pixel-perfect UI, he makes IntelUniVen’s interface not just functional, but delightful. Whether it’s responsive layouts or intuitive navigation, he brings ideas to life — beautifully.\n\n“Good design is invisible — but it leaves an impression.”`
  },
  {
    name: 'Yashasvi Pandey',
    role: 'Full Stack Developer',
    image: require('../assets/images/yashasvi.jpg'),
    description: `Yashasvi handles the logic, servers, and databases that power everything under the hood. With a knack for solving complex problems and building rock-solid APIs, she makes sure the system works smoothly — no matter how heavy the traffic or how complex the query.\n\n“You don’t see my work, but you feel it every time the system doesn’t crash.”`
  }
];

const MeetOurDeveloper = () => {
  return (
    <>
      <CustomHeader activePage="about" />
      <section className="about-hero">
        <h1>Meet Our Developers</h1>
        <p>Our talented developer team brings your ideas to life with passion and expertise.</p>
      </section>
      <div className="about-content">
        <div className="team-grid">
          {developers.map((dev, idx) => (
            <div className="team-card" key={idx}>
              <div className="team-avatar">
                <img src={dev.image} alt={dev.name} onError={e => { e.target.style.display = 'none'; e.target.nextElementSibling.style.display = 'flex'; }}
                  className={dev.name === 'Yashasvi Pandey' ? 'yashasvi-img' : ''}
                />
                <div className="initials">{dev.name.split(' ').map(n => n[0]).join('')}</div>
              </div>
              <h4>{dev.name}</h4>
              <div className="role">{dev.role}</div>
              <p>{dev.description}</p>
            </div>
          ))}
        </div>
      </div>
      <CustomFooter />
    </>
  );
};

export default MeetOurDeveloper;